export default __webpack_public_path__ + "static/media/yl.efe2e73d.png";